<template>
  <div class="modal-card">
    <div class="modal-card-head">
      <div class="modal-card-title">Access request</div>
    </div>
    <div class="modal-card-body">
      <div class="columns">
        <div class="column">
          <div class="my-2">Please remember that all selected role(s) and group(s) will be applied to the primary users and all additional users listed below.</div>

          <b-field label="Roles">
            <b-taginput placeholder="Select the User's Roles"
                        autocomplete
                        type="is-primary"
                        field="Name"
                        v-model="request.Roles"
                        :data="filteredRoles"
                        @typing="filterRoles"
                        open-on-focus>
            </b-taginput>
          </b-field>

          <RoleDescriptions class="my-2"></RoleDescriptions>

          <h3>Groups</h3>
          <span v-if="$store.getters.isAdmin">If you would like to create a group, follow <a @click="goToGroupAdmin">this link.</a></span>
          <b-field label="CTC Groups">
            <b-taginput placeholder="Select the User's Groups"
                        autocomplete
                        type="is-primary"
                        field="Name"
                        v-model="request.Groups"
                        :data="filteredGroups"
                        @typing="filterGroups"
                        open-on-focus>
            </b-taginput>
          </b-field>
          <b-field label="ACC Group">
            <b-select v-model="request.CalculatorGroup" placeholder="Select a group" expanded>
              <option :value="null">No Group</option>
              <option v-for="group in groups" :value="group.Id">{{group.Name}}</option>
            </b-select>
          </b-field>
          <b-field label="Name of organisation requesting access">
            <b-input placeholder="Organisation" v-model="request.Organization"></b-input>
          </b-field>
          <b-field label="Name of administrator of requesting organisation">
            <b-input placeholder="Name" v-model="request.Name"></b-input>
          </b-field>
          <b-field label="Administrator title within requesting organisation">
            <b-input placeholder="Title" v-model="request.Title"></b-input>
          </b-field>
          <b-field>
            <template slot="label">
              <b>Administrator contact email</b>&nbsp;
              <b-tooltip label="If use is approved this person will be the default administrator for the organisation"
                         position="is-top"
                         multilined>
                <i class="fas fa-question-circle"></i>
              </b-tooltip>
            </template>
            <b-input type="text" placeholder="Email address" v-model="request.PrimaryEmail"></b-input>
          </b-field>
          <b-field label="Reasoning for access request">
            <b-input type="textarea" placeholder="Reasoning for access request" v-model="request.Reasoning"></b-input>
          </b-field>
          <b-field>
            <template slot="label">
              <b>Names and email addresses of other intended users of the AWG carbon calculator within the organisation</b>&nbsp;
              <b-tooltip label="Users will need to have email addresses within the same website domain as the primary contact email above"
                         position="is-top"
                         multilined>
                <i class="fas fa-question-circle"></i>
              </b-tooltip>
            </template>
            <EditRequestInfo @updateUsers="users = $event" :preAdd="users"></EditRequestInfo>
          </b-field>
        </div>
      </div>
    </div>
    <div class="modal-card-foot">
      <b-button @click="$parent.close()">Close</b-button>
      <div class="is-pulled-right">
        <div v-if="Request.Status == 'In Progress'">
          <b-button class="is-danger" @click="deny">Deny</b-button>
          <b-button class="is-primary" @click="approve">Approve</b-button>
        </div>
        <div v-if="Request.Status != 'In Progress'">
          <span>{{ Request.Status }}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import EditRequestInfo from "@/components/admin/users/requestInfo.vue";
  import RoleDescriptions from "@/components/admin/users/roleDescriptions.vue";
  export default {
    components: {
      EditRequestInfo,
      RoleDescriptions
    },
    props: {
      Request: Object
    },
    data() {
      return {
        request: {},
        users: [],
        filteredGroups: [],
        groups: [],
        roles: [],
        filteredRoles: [],
        isActive: false
      }
    },
    methods: {
      approve() {
        if (this.request.Organization && this.request.PrimaryEmail && this.request.PrimaryId && this.request.Name && this.request.Title && this.request.Roles && this.request.CalculatorGroup) {
          this.request.Emails = this.users;
          this.request.Emails.push({ Id: this.request.PrimaryId, Email: this.request.PrimaryEmail, Name: this.request.Name, Title: this.request.Title });

          this.$http.post("api/request/approve", { Request: this.request, Roles: this.request.Roles, Groups: this.request.Groups, CalculatorGroup: this.request.CalculatorGroup })
            .then(resp => {
              this.$buefy.toast.open(resp.data);
              this.$parent.close();
              this.$emit("refresh");
            }).catch(e => {
              console.error(e)
            });
        }
        else {
          this.$buefy.toast.open("You must fill out all fields other than the extra users field.");
        }
      },
      deny() {
        this.$http.get("api/request/deny/" + this.request.Id)
          .then(resp => {
            this.$buefy.toast.open(resp.data);
            this.$parent.close();
            this.$emit("refresh");
          }).catch(e => {
            console.error(e)
          });
      },
      goToGroupAdmin() {
        this.$parent.close();
        this.$router.push("/admin/groups");
      },
      filterGroups(text) {
        this.filteredGroups = this.groups.filter((option) => {
          return option
            .Name
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0;
        })
      },
      filterRoles(text) {
        this.filteredRoles = this.roles.filter((option) => {
          return option
            .Name
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0;
        })
      },
    },

    async created() {
      if (this.Request.Users) {
        this.Request.Users.forEach(u => {
          if (u.IsPrimary == false)
            this.users.push({ Id: u.Id, Email: u.Email, Name: u.Name, Title: u.Title });
          else {
            this.request.Name = u.Name;
            this.request.Title = u.Title;
            this.request.PrimaryEmail = u.Email;
            this.request.PrimaryId = u.Id;
          }
        })
      }
      this.request.Id = this.Request.Id;
      this.request.Organization = this.Request.Organization;
      this.request.Reasoning = this.Request.Reasoning;

      var t1 = this.$http.get("api/roles")
        .then(resp => {
          this.roles = resp.data;
        }).catch(err => {
          console.error(err);
        });

      var t2 = this.$http.get("api/group")
        .then(resp => {
          this.groups = resp.data;
        }).catch(err => {
          console.error(err);
        });

      await Promise.all([t1, t2]);

      this.filteredGroups = this.groups;
      this.filteredRoles = this.roles;


    }
  }
</script>
